import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-detail-cvs',
    templateUrl: './detail-cvs.component.html',
    styleUrls: ['./detail-cvs.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class DetailCvsComponent {}
